import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home as HomeIcon, LogIn, Menu, X, LayoutGrid } from "lucide-react";
import { useState } from "react";
import Logo from "@/library/components/Logo";

const NavBar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const linkCls = (path) =>
    `px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
      loc.pathname === path
        ? "bg-brand text-white"
        : "text-slate-700 hover:bg-slate-100"
    }`;

  return (
    <nav data-testid="main-navbar" className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/library" data-testid="nav-logo">
          <Logo />
        </Link>

        <div className="hidden md:flex items-center gap-2">
          <Link to="/" data-testid="nav-portal" className="px-4 py-2 rounded-lg text-sm font-semibold text-slate-700 hover:bg-slate-100 flex items-center gap-1.5">
            <LayoutGrid className="w-4 h-4" /> البوابة
          </Link>
          <Link to="/library" className={linkCls("/library")} data-testid="nav-home"><HomeIcon className="inline w-4 h-4 ms-1" /> الرئيسية</Link>
          <Link to="/library/levels" className={linkCls("/library/levels")} data-testid="nav-levels">المراحل</Link>
          <Link to="/library/staff/browse" className={linkCls("/library/staff/browse")} data-testid="nav-staff-browse">المنسوبون</Link>
          <Link to="/library/admin/login" data-testid="nav-admin-login" className="px-4 py-2 rounded-lg text-sm font-semibold bg-gradient-to-l from-gold to-gold-dark text-white shadow-md hover:shadow-lg transition-shadow flex items-center gap-2">
            <LogIn className="w-4 h-4" /> دخول الإدارة
          </Link>
        </div>

        <button data-testid="nav-toggle" className="md:hidden p-2" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 px-4 py-3 space-y-2 bg-white">
          <Link to="/" onClick={() => setOpen(false)} className="block px-4 py-2 rounded-lg hover:bg-slate-100 flex items-center gap-1.5" data-testid="m-nav-portal"><LayoutGrid className="w-4 h-4" /> البوابة</Link>
          <Link to="/library" onClick={() => setOpen(false)} className="block px-4 py-2 rounded-lg hover:bg-slate-100" data-testid="m-nav-home">الرئيسية</Link>
          <Link to="/library/levels" onClick={() => setOpen(false)} className="block px-4 py-2 rounded-lg hover:bg-slate-100" data-testid="m-nav-levels">المراحل</Link>
          <Link to="/library/staff/browse" onClick={() => setOpen(false)} className="block px-4 py-2 rounded-lg hover:bg-slate-100" data-testid="m-nav-staff-browse">المنسوبون</Link>
          <Link to="/library/admin/login" onClick={() => setOpen(false)} className="block px-4 py-2 rounded-lg bg-gold text-white text-center" data-testid="m-nav-admin">دخول الإدارة</Link>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
